import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';

import { StatementDialogComponent } from './statement-dialog.component';

@NgModule({
	declarations: [StatementDialogComponent],
	imports: [CommonModule, DialogModule],
	exports: [StatementDialogComponent],
})
export class StatementDialogModule {}
